/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */

define(['underscore'], function(_) {
	const MAX_DECIMAL_PLACES = 2;

	class BinningActionsUtils {
		static getBinningFilters(localFilters, dataItem) {
			//@todo need clean up when completely hookup to using new API
			let binning;
			let binnedFilters;
			binning = dataItem.getBinning();
			if (binning) {
				binnedFilters = localFilters.getFilterEntries(localFilters.getCategoryFilterKey(dataItem.getColumnId(), dataItem.getId()));
			}
			return binnedFilters;
		}

		static removeLocalBinnedFilterEntries (localFilters, binnedFilters, options) {
			if (binnedFilters && binnedFilters.length && localFilters) {
				binnedFilters.forEach(binnedFilter => {
					localFilters.removeFilterEntry(binnedFilter, options);
				});
				localFilters.allFilterModificationComplete();
			}
		}

		/**
		 * Clear compound filters for slot.
		 *
		 */
		static removeCompoundFilters (slot, localFilters, options) {
			if (localFilters && localFilters.models) {
				let columnIdsInSlot;
				let dataItemAPIs = slot.getDataItemList();
				columnIdsInSlot = dataItemAPIs ? _.map(dataItemAPIs, function (dataItem) {
					return dataItem.getColumnId();
				}) : [];
				localFilters.clearCompoundFilters(columnIdsInSlot);
				localFilters.allFilterModificationComplete(options);
			}
		}

		static getBinningFilterForFormatedItem(formatSpec, localFilters, dataItem) {
			var format = dataItem.getFormat();

			// So that we can support the new dataItem API as well
			if(format.formatSpec){
				format = format.formatSpec;
			}

			var maximumFractionDigits = format && (format.maximumFractionDigits || format.maximumFractionDigits === 0) ? format.maximumFractionDigits : MAX_DECIMAL_PLACES;
			var binningFilters;
			if ((formatSpec.maximumFractionDigits || formatSpec.maximumFractionDigits === 0) && formatSpec.maximumFractionDigits !== maximumFractionDigits) {
				binningFilters = BinningActionsUtils.getBinningFilters(localFilters, dataItem);
			}
			return binningFilters;
		}

		/**
		 * Find the correct data item index
		 * @param {Object} slot - slot api for slot we're checking against
		 * @param {Integer} index - index of the data item we want to check, can be derived from slotState.mapIndex
		 * @return {Integer || Null} Returns the index of the first data item in this slot that has the appropriate type for autobinning or null if none is found
		 */
		static findDataItemIndex(slot, index) {
			// when this path is triggered from rclick on axis title, we get the wrong mapindex for the data item
			// index is null but we have data items, maybe 1st dataitem isnt the right one which is the behaviour we saw by letting the incorrect index propagate forward
			// works fine if its from data slots view, mapindex comes in defined and correct
			if (typeof index !== 'number' && slot.getDataItemList().length > 0) {
				const dataItemAPIs = slot.getDataItemList();
				_.find(dataItemAPIs, (dApi, idx) => {
					if (dApi.getMetadataColumn().getType() === 'fact') {
						index = idx;
						return true;
					}
				});
			}
			return index;
		}

		/**
		 * @param {Object} visAPI - API for current viz we want to check against
		 * @param {Object} slot - slot api for slot we're checking against
		 * @param {Object} dataItemAPI - dataItem API to check against
		 * @return {Boolean} Returns true if autobinning is enabled on the viz (via vipr props),
		 *  and there's autobinning on the slot with context and (the slot has a context binning data item or the dataitemAPI contains the autobinning api(in case of other types of data))
		 */
		static isDataItemBinned (dataItemAPI) {
			return dataItemAPI.isBinned();
		}

		static doesWidgetConfigSupportAutobinning (config = {}) {
			return config.auto === true;
		}
	}

	return BinningActionsUtils;
});
